import ThankYou from 'components/thankYou/ThankYou'
import React from 'react'

const ThankYouPage = () => {
    return (
        <div>
            <ThankYou />
        </div>
    )
}

export default ThankYouPage